interface DevToolsGuardOptions {
  onDevToolsOpen?: () => void;
  checkInterval?: number;
}

export class DevToolsGuard {
  private checkInterval: number;
  private intervalId?: number;
  private onDevToolsOpen: () => void;
  private browserInfo: {
    isFirefox: boolean;
    isChrome: boolean;
    isSafari: boolean;
    isEdge: boolean;
  };

  constructor(options: DevToolsGuardOptions = {}) {
    this.checkInterval = options.checkInterval || 1000;
    this.onDevToolsOpen = options.onDevToolsOpen || (() => { 
      debugger;
      setInterval(() => { debugger; }, 100);
    });

    // Detect browser
    this.browserInfo = {
      isFirefox: navigator.userAgent.includes('Firefox'),
      isChrome: navigator.userAgent.includes('Chrome') && !navigator.userAgent.includes('Edge'),
      isSafari: navigator.userAgent.includes('Safari') && !navigator.userAgent.includes('Chrome'),
      isEdge: navigator.userAgent.includes('Edge') || navigator.userAgent.includes('Edg'),
    };
  }

  private handleKeydown = (e: KeyboardEvent) => {
    // Common shortcuts across all browsers
    const isDevToolsKey = (
      e.key === 'F12' ||
      // Windows/Linux shortcuts
      (e.ctrlKey && e.shiftKey && ['I', 'J', 'C', 'K'].includes(e.key)) ||
      (e.ctrlKey && e.key === 'u') ||
      // macOS shortcuts
      (e.metaKey && e.altKey && ['I', 'J', 'C', 'K'].includes(e.key)) ||
      (e.metaKey && e.key === 'u') ||
      // Firefox specific
      (this.browserInfo.isFirefox && e.shiftKey && e.key === 'K') ||
      // Safari specific
      (this.browserInfo.isSafari && e.metaKey && e.altKey && e.key === 'U')
    );

    if (isDevToolsKey) {
      e.preventDefault();
      e.stopPropagation();
      this.onDevToolsOpen();
    }
  };

  private detectDevTools = () => {
    const threshold = this.browserInfo.isSafari ? 80 : 160; // Safari needs a lower threshold
    
    // Basic size detection
    const isDevToolsOpen = 
      window.outerWidth - window.innerWidth > threshold ||
      window.outerHeight - window.innerHeight > threshold;

    // Browser-specific checks
    const browserSpecificChecks = 
      // Chrome/Edge DevTools
      (window as any).__REACT_DEVTOOLS_GLOBAL_HOOK__ ||
      // Firefox DevTools
      (window as any).Firebug?.chrome?.isInitialized ||
      // Safari DevTools
      (this.browserInfo.isSafari && (window as any).__SAFARI_DEVTOOLS_GLOBAL_HOOK__) ||
      // General console opening detection
      (/./g).test(function() { return 'dev' }) ||
      // Additional Chrome/Edge check
      (this.browserInfo.isChrome && (window as any).chrome?.app?.InstallState) ||
      // Additional Firefox check
      (this.browserInfo.isFirefox && (window as any).console.firebug);

    if (isDevToolsOpen || browserSpecificChecks) {
      this.onDevToolsOpen();
    }
  };

  private setupBrowserSpecificProtection() {
    // Chrome/Edge protection
    if (this.browserInfo.isChrome || this.browserInfo.isEdge) {
      Object.defineProperty(window, '__REACT_DEVTOOLS_GLOBAL_HOOK__', {
        get() { debugger; return undefined; }
      });
    }

    // Firefox protection
    if (this.browserInfo.isFirefox) {
      Object.defineProperty(window, 'Firebug', {
        get() { debugger; return undefined; }
      });
    }

    // Safari protection
    if (this.browserInfo.isSafari) {
      Object.defineProperty(window, '__SAFARI_DEVTOOLS_GLOBAL_HOOK__', {
        get() { debugger; return undefined; }
      });
    }

    // Universal protection
    const consoleProxy = new Proxy(console, {
      get(target, prop) {
        if (prop === 'log' || prop === 'info' || prop === 'warn' || 
            prop === 'error' || prop === 'debug' || prop === 'dir') {
          return () => undefined;
        }
        return target[prop as keyof typeof target];
      }
    });

    Object.defineProperty(window, 'console', {
      get() { return consoleProxy; }
    });
  }

  public enable() {
    // Event listeners with capture
    document.addEventListener('keydown', this.handleKeydown, { capture: true, passive: false });
    window.addEventListener('resize', this.detectDevTools, { capture: true });
    
    // Regular checks
    this.intervalId = window.setInterval(this.detectDevTools, this.checkInterval);

    // Browser-specific protection
    this.setupBrowserSpecificProtection();

    // Additional protection for all browsers
    window.addEventListener('contextmenu', (e) => {
      if (e.shiftKey || e.ctrlKey || e.altKey || e.metaKey) {
        e.preventDefault();
      }
    }, { capture: true });
  }

  public disable() {
    document.removeEventListener('keydown', this.handleKeydown, { capture: true });
    window.removeEventListener('resize', this.detectDevTools, { capture: true });
    if (this.intervalId) {
      window.clearInterval(this.intervalId);
    }
  }
} 